import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaCentroCustoModel } from "../models/centroCusto/buscaCentroCustoModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarCentroCusto, setModalDeletarCentroCusto } from "../redux/slices/centroCusto/centroCustoSlice";

export const cadastrarCentroCusto = createAsyncThunk("/CentroCusto/CadastrarCentroCusto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/CentroCusto/CadastrarCentroCusto", payload.value);
    toastSucess("Centro de custo cadastrado com sucesso");
    dispatch(setModalCadastrarCentroCusto(false));
    dispatch(setLoading(false));

    dispatch(buscarCentroCusto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarCentroCusto = createAsyncThunk("/CentroCusto/BuscarCentroCusto", async (args: BuscaCentroCustoModel) => {
  try {
    const data = await api.get("/CentroCusto/BuscarCentroCusto", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarCentroCusto = createAsyncThunk("/CentroCusto/AtualizarCentroCusto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/CentroCusto/AtualizarCentroCusto", payload.value);
    toastSucess("Centro de custo atualizado com sucesso");
    dispatch(setModalCadastrarCentroCusto(false));
    dispatch(setLoading(false));

    dispatch(buscarCentroCusto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarCentroCustoAtivo = createAsyncThunk("/CentroCusto/AtualizarCentroCustoAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/CentroCusto/AtualizarCentroCustoAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status do centro de custo atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarCentroCusto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarCentroCusto = createAsyncThunk("/CentroCusto/DeletarCentroCusto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/CentroCusto/DeletarCentroCusto/?id=" + payload.value);
    toastSucess("Centro de custo removido com sucesso");
    dispatch(setModalDeletarCentroCusto(false));

    dispatch(setLoading(false));

    dispatch(buscarCentroCusto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
